import { Select as SelectPrimitive } from '@base-ui/react/select';

import { cn } from '@/lib/utils';

export type SelectGroupProps = SelectPrimitive.Group.Props;

const SelectGroup = ({ className, children, ...props }: SelectGroupProps) => {
  return (
    <SelectPrimitive.Group
      data-slot="select-group"
      className={cn('scroll-my-1 p-1', className)}
      {...props}
    >
      {children}
    </SelectPrimitive.Group>
  );
};

export default SelectGroup;
